<mat-tab-group>
  @if (helper.tieneModulo('Alarmas')) {
    <mat-tab label="Alarmas">
      <ng-template matTabContent>
        <app-exportaciones-alarmas></app-exportaciones-alarmas>
      </ng-template>
    </mat-tab>
  }
  @if (helper.tieneModulo('Vehículos')) {
    <mat-tab label="Vehículos">
      <ng-template matTabContent>
        <app-exportaciones-vehiculos></app-exportaciones-vehiculos>
      </ng-template>
    </mat-tab>
  }
</mat-tab-group>
